<template>
    <div class="breadcrumbs">
        <div class="wrapper">
            <router-link class="link" to="/">Веб-кабинет</router-link> &mdash; 
            <span v-if="$route.name === 'assortmentItem'">
                <router-link class="link" to="/assortment">Ассортимент: новинки/хиты сезона</router-link>
            </span>
            <span v-else>{{ routeName }}</span>
        </div>
    </div>
</template>

<script>
 export default {
     props: ['routeName']
 }
</script>